var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.241064 0.745899C0.533264 0.44784 0.990508 0.420743 1.31272 0.66461L1.40503 0.745899L8 7.47342L14.595 0.745899C14.8872 0.44784 15.3444 0.420743 15.6666 0.66461L15.7589 0.745899C16.0511 1.04396 16.0777 1.51037 15.8386 1.83904L15.7589 1.93321L8.58198 9.2541C8.28978 9.55216 7.83254 9.57926 7.51033 9.33539L7.41802 9.2541L0.241064 1.93321C-0.0803548 1.60534 -0.0803548 1.07376 0.241064 0.745899Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.51f13b4134da0a06abc5e39c0ebce991.svg";
export { ForwardRef as ReactComponent };